import { twMerge } from "tailwind-merge";

const InitialsLogo = ({
  name,
  className = "",
  imgSrc,
}: {
  name: string;
  className?: string;
  imgSrc: string;
}) => {
  const getRandomColor = (str: string) => {
    if (!str) return "%000";
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }
    return colour;
  };

  return imgSrc ? (
    <img
      alt={name + " profile picture"}
      src={imgSrc}
      className={twMerge(
        `aspect-square size-8 min-w-8 max-w-full rounded-full bg-gray-800`,
        className
      )}
    />
  ) : (
    <span
      style={{ background: getRandomColor(name) }}
      className={twMerge(
        `item-center inline-flex aspect-square h-8 w-8 min-w-8 justify-center rounded-full text-base leading-8 text-white`,
        className
      )}
    >
      <span className="h-auto drop-shadow-[0px_0px_2px_black]">
        {String(name)[0]?.toUpperCase() ?? "C"}
      </span>
    </span>
  );
};

export default InitialsLogo;
